window.addEventListener("DOMContentLoaded", (event) => {
  const blockCheckbox = document.querySelector("#show_checkbox");
  if (blockCheckbox) {
    document.querySelector(".bundle_service_product").style.display = "none";
    blockCheckbox.addEventListener("change",function(elm){
      if (blockCheckbox.checked == true) {
        document.querySelector(".bundle_service_product").style.display = "block";
        document.querySelector("product-form.product-form form").style.display = "none";
      }
      else{
        document.querySelector(".bundle_service_product").style.display = "none";
        document.querySelector("product-form.product-form form").style.display = "block";
      }
    });

    async function serviceAddToCart(items) {
      try {        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(items)
        });
        const resdata = await response.json();
        console.log(resdata);
      } catch (error) {
        console.error(error);
      }
    }

     // add buddle product
    document.querySelector(".bundle_service_product form").addEventListener("submit", function (event) {
    event.preventDefault();
      let prefId = document.querySelector('.bundle_service_product form input[service_prd]').getAttribute("service_prd");
      let prdId = document.querySelector('.bundle_service_product form input[service_prd]').getAttribute("value");
      let prefDate = document.querySelector("#preferred_date").value;
      let prefQty = document.querySelector("#preferred_Qty").value;
      let prdQty = document.querySelector('.product-form__input .quantity__input').value;
      let prefAddress = document.querySelector("#preferred_address").value;
      let data = {
        items: [
          {
            id: prefId,
            quantity: prefQty,
            properties: {
              preferred_date: prefDate,
              preferred_address: prefAddress
            }
          }
        ]
      };
      if (prefDate !== '' && prefAddress !== '') {
        document.querySelector('.select_reqire_field_text').style.display = "none";
        serviceAddToCart(data);
        setTimeout(() => {
          document.querySelector('.product-form button').click()
        }, 500);
      }
        else{
          document.querySelector('.select_reqire_field_text').style.cssText = `display: block; color: #f00; padding-bottom: 10px;`;
      if(prefDate == '' && prefAddress == ''){
          document.querySelector('.select_reqire_field_text').innerHTML = "Fill required field, Preferred installation date and Preferred address";
      }
      else if(prefDate == ''){
          document.querySelector('.select_reqire_field_text').innerHTML = "Fill required field, Preferred installation date";
      }
      else if(prefAddress == ''){
          document.querySelector('.select_reqire_field_text').innerHTML = "Fill required field, Preferred address";
      } 
        }
    });
    

  }
    //// show line properties
    let addtobtn  = document.querySelector('.form .product-form__buttons');
    if (document.querySelector('.service-product')){
      addtobtn.style.display = 'none';

      // change price on click qty
      const priceFixEl = document.querySelector('.price__regular .price-item').innerText;
      const price_dot_val = (priceFixEl.length - 1) - (priceFixEl.indexOf("."));
        document.querySelector(".Qty_change").addEventListener("change", function (event) {
          let crunt_price = (priceFixEl.replace(/£/g, "") * this.value);
        document.querySelector('.price__regular .price-item').innerHTML = priceFixEl.replace(/[0-9.]/g, '') + crunt_price.toFixed(price_dot_val);
      });

    }
      
    document.querySelector(".custom_btn_submit button").addEventListener("click", function (event) {
      event.preventDefault();
      let prefDate = document.querySelector("#preferr_date").value;
      let prefAddress = document.querySelector("#preferr_address").value;
      //console.log(prefDate);

      if (prefDate !== '' && prefAddress !== '') {
        document.querySelector('.select_reqire_field_text--simple-product').style.display = "none"; 
        setTimeout(() => {
          document.querySelector('.product-form button').click()
        }, 500);
        
      }
      else{
        document.querySelector('.select_reqire_field_text--simple-product').style.cssText = `display: block; color: #f00; padding-bottom: 10px;`;
      if(prefDate == '' && prefAddress == ''){
          document.querySelector('.select_reqire_field_text--simple-product').innerHTML = "Fill required field, Preferred installation date and Preferred address";
      }
      else if(prefDate == ''){
          document.querySelector('.select_reqire_field_text--simple-product').innerHTML = "Fill required field, Preferred installation date";
      }
      else if(prefAddress == ''){
          document.querySelector('.select_reqire_field_text--simple-product').innerHTML = "Fill required field, Preferred address";
      } 
        }
    });
});